export function PaginationItemDot() {
  return (
    <span className="w-9 leading-10 text-center">
      ...
    </span>
  )
}